// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { minutesToHours as fn } from "../minutesToHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const minutesToHours = convertToFP(fn, 1);

// Fallback for modularized imports:
export default minutesToHours;
